import { ID } from "@/data/types/Basic"
import React, { FC } from "react"

export const TrustedShopsReviewCarouselRv: FC<{ id: ID }> = ({ id: _id }) => {
    return React.createElement('etrusted-widget', {
        'data-etrusted-widget-id': 'wdg-753cb8d8-fc7c-4399-bafc-564b7886521d',
    });
}